import Vue from 'vue'

Vue.filter('pluralize', function(value, singular, plural) {
    if(value>1) {
        if(plural) {
            return plural
        }
        else {
            return singular + 's'
        }
    }
    else {
        return singular
    }
})



// WEBPACK FOOTER //
// ./src/filters/pluralize.js